// import Cookies from 'js-cookie';
// import moment from 'moment-timezone';

import { IconButton } from '../../../components/Shared';
// import { DATE_TIME_FORMAT, DEFAULT_IANA_TIME_ZONE } from '../../../constants';
// import {
//   getFormattedDateInMomentDefaultTZ,
//   getUTCOffsetInHoursAsString,
// } from '../../../helpers';

// const getBookedDate = (timezone, pickedDate, pickedTime) => {
//   const date = getFormattedDateInMomentDefaultTZ(pickedDate);
//   const time = moment(pickedTime, DATE_TIME_FORMAT.h_mm_A);

//   return date
//     .set({
//       hour: time.hour(),
//       minute: time.minute(),
//       second: 0,
//       millisecond: 0,
//     })
//     .tz(timezone)
//     .format(DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A);
// };

export const PanelEditContact = ({ lead, pickedDate, pickedTime, action }) => {
  // const leadIANATimeZone = lead.time;
  // const sdrIANATimeZone = Cookies.get('ianaTimeZone') ?? DEFAULT_IANA_TIME_ZONE;

  return (
    <div className="rounded-[20px] bg-white/30 py-3 pl-6 pr-5 flex gap-2">
      <div className="flex flex-col w-full truncate gap-2">
        <div className="flex flex-col w-full">
          <span className="text-brand-900 font-semibold text-[18px]/[28px] truncate">
            {lead.contact}
          </span>
          <span className="text-base-800 font-normal text-[16px]/[24px] truncate">
            {lead.company}
          </span>
        </div>
        {/* TODO: waiting for the new design */}
        {/* <div className="flex gap-2">
          <span className="font-medium text-[14px]/[20px] text-base-800">
            Lead Time Zone:
          </span>
          {!leadIANATimeZone ? (
            <span className="text-[14px]/[20px] text-base-600 truncate">
              No Timezone Available
            </span>
          ) : (
            <div className="flex flex-col truncate">
              <span className="font-medium text-[14px]/[20px] text-base-1000 truncate">
                {`${getUTCOffsetInHoursAsString(leadIANATimeZone)} ${leadIANATimeZone}`}
              </span>
              {!pickedTime ? (
                <span className="text-[14px]/[20px] text-base-600 truncate">
                  Select date&time
                </span>
              ) : (
                <span className="text-[14px]/[20px] text-base-1000 truncate">
                  {getBookedDate(leadIANATimeZone, pickedDate, pickedTime)}
                </span>
              )}
            </div>
          )}
        </div>
        <div className="flex gap-2">
          <span className="font-medium text-[14px]/[20px] text-base-800">
            SDR Time Zone:
          </span>
          <div className="flex flex-col truncate">
            <span className="font-medium text-[14px]/[20px] text-base-1000 truncate">
              {`${getUTCOffsetInHoursAsString(sdrIANATimeZone)} ${sdrIANATimeZone}`}
            </span>
            {!pickedTime ? (
              <span className="text-[14px]/[20px] text-base-600 truncate">
                Select date&time
              </span>
            ) : (
              <span className="text-[14px]/[20px] text-base-1000 truncate">
                {getBookedDate(sdrIANATimeZone, pickedDate, pickedTime)}
              </span>
            )}
          </div>
        </div> */}
      </div>
      <IconButton
        buttonProps={{ onClick: action }}
        iconProps={{ name: 'edit', alt: 'edit', className: 'h-5' }}
      />
    </div>
  );
};
